/* eslint-disable react/jsx-closing-bracket-location */
import CircularProgress from '@material-ui/core/CircularProgress';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import Fab from '@material-ui/core/Fab';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import axios from 'axios';
import { keyBy } from 'lodash';
import mime from 'mime-types';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { IIFC } from 'react-iifc';
import Swal from 'sweetalert2';
import Icon from './Visited.svg';

import { getDate, getMonth, getYear } from 'date-fns';
import { useMediaQuery } from 'react-responsive';
import { LogError } from '../../../AppUtil/AppUtil';
import BuxService from '../../../Service/BuxService';
import Session from '../../../Service/Session';
import UserService from '../../../Service/UserService';
import Alert from '../../Common/AlertContainer';
import { commonStyle } from '../../Common/CommonStyle';
import Error from '../../Common/Error';
import InputLabelMobile from '../../Common/Profile/InputLabelMobile';
import MobileFooter from '../../Common/Profile/MobileFooter';
import PageHeaderTitle from '../../Common/Profile/PageHeaderTitle';

const APP_STRING = window.AppStrings;
const { MOBILE } = window.AppConfig.SCREEN_SIZE;

class index extends Component {
	// NOSONAR
	constructor(props) {
		super(props);
		this.state = {
			_error: null,
			_errorFromEdit: '',
			_isResendingOtp: false,
			_isOptSubmitBtnLoaderOn: false,
			allowResendOtp: false,
			otp: '',
			_alert: {
				_show: false,
				_message: '',
				_severity: ''
			}
		};
	}

	otpChangeHandler(otp, _type) {
		this.setState({ otp: otp.target.value, _error: null });
	}

	getOtp() {
		const otp = this.state.otp;
		return otp.toString();
	}

	getcontactSuffix(phone) {
		return phone.slice(3);
	}

	createFile = async (url, fileName) => {
		const response = await fetch(url);
		const blob = await response.blob();
		const metadata = { type: mime.lookup(fileName) };
		const file = new File([blob], fileName, metadata);
		return file;
	};

	createWallet = async () => {
		const contactSuffix = this.getcontactSuffix(this.props.currentUser.profile.phone);
		const walletPayload = {
			email: this.props.dwollaSignUpForm.emailId.value,
			contact: contactSuffix,
			first_name: this.props.dwollaSignUpForm.firstName.value,
			last_name: this.props.dwollaSignUpForm.lastName.value
		};
		try {
			return await BuxService.buxCreateWallet(walletPayload);
		} catch (err) {
			LogError(err.message);
		}
	};

	submitKyc = async () => {
		const contactSuffix = this.getcontactSuffix(this.props.currentUser.profile.phone);

		const uploadedIds = await UserService.signedUrlUploadId(this.props.currentUser.profile.id, {
			type: 'getObject'
		});
		Session.store(APP_STRING.UPLOAD_ID, uploadedIds);
		const uploadedIdsObj = keyBy(uploadedIds.data.data, 'id');

		const payloadKyc = {
			email: this.props.dwollaSignUpForm.emailId.value,
			sub_email: this.props.dwollaSignUpForm.emailId.value,
			contact: contactSuffix,
			first_name: this.props.dwollaSignUpForm.firstName.value,
			middle_name: this.props.dwollaSignUpForm.middleName.value,
			last_name: this.props.dwollaSignUpForm.lastName.value,
			birthday: this.getDateFormat(this.props.dwollaSignUpForm.dob.value),
			birthplace: this.props.dwollaSignUpForm.birthplace.value,
			present_street: this.props.dwollaSignUpForm.address.value,
			present_barangay: this.props.dwollaSignUpForm.barangay.value,
			present_city: this.props.dwollaSignUpForm.city.value,
			present_province: this.props.dwollaSignUpForm.province.value,
			present_postcode: this.props.dwollaSignUpForm.postalCode.value,
			civil_status: this.props.dwollaSignUpForm.civilStatus.value.value,
			gender: this.props.dwollaSignUpForm.gender.value,
			mothers_first_name: this.props.dwollaSignUpForm.motherFirstName.value,
			mothers_last_name: this.props.dwollaSignUpForm.motherLastName.value,
			id_type: this.props.dwollaSignUpForm.idType.value.value,
			id_number: this.props.dwollaSignUpForm.idNumber.value,
			source_of_funds: this.props.dwollaSignUpForm.sourceOfFunds.value.value,
			employment_status: this.props.dwollaSignUpForm.employmentStatus.value.value,
			employer_name: this.props.dwollaSignUpForm.employerName.value,
			employer_industry: this.props.dwollaSignUpForm.employerIndustry.value.value,
			employer_street: this.props.dwollaSignUpForm.employerStreet.value,
			employer_barangay: this.props.dwollaSignUpForm.employerBarangay.value,
			employer_city: this.props.dwollaSignUpForm.employerCity.value,
			employer_province: this.props.dwollaSignUpForm.employerProvince.value,
			employer_postcode: this.props.dwollaSignUpForm.employerPostalCode.value,
			front_id_image: await this.createFile(uploadedIdsObj['frontId'].url, uploadedIdsObj['frontId'].value),
			back_id_image: await this.createFile(uploadedIdsObj['backId'].url, uploadedIdsObj['backId'].value),
			selfie_image: await this.createFile(uploadedIdsObj['selfie'].url, uploadedIdsObj['selfie'].value)
		};

		const payloadFormData = new FormData();
		Object.keys(payloadKyc).map(key => payloadFormData.append(key, payloadKyc[key]));

		try {
			const response = await BuxService.buxSubmitKyc(payloadFormData);

			return response;
		} catch (err) {
			console.log('submit kyc error', err);
			LogError(err.message);
		}
	};

	onsubmitFormHandler = async e => {
		e.preventDefault();

		const otp = this.getOtp();

		// VALIDATIONS
		if (otp.length !== 6) {
			this.setState({ _error: 'error_message.invalid_code' });
			return false;
		}

		this.setState({ _isOptSubmitBtnLoaderOn: true });
		try {
			const payload = {
				Recipient: this.props.dwollaSignUpForm.emailId.value,
				Code: otp
			};
			const response = await BuxService.getEmailVerify(payload);
			if (response) {
				const userInfo = {
					...this.props.dwollaSignUpForm
				};

				const updateUser = {
					email: userInfo.emailId.value,
					middle_name: userInfo.middleName.value,
					id_type: userInfo.idType.value,
					id_number: userInfo.idNumber.value,
					civil_status: userInfo.civilStatus.value,
					gender: userInfo.gender.value,
					birth_place: userInfo.birthplace.value,
					address: userInfo.address.value,
					city: userInfo.city.value,
					province: userInfo.province.value,
					barangay: userInfo.barangay.value,
					dob: this.getDateFormat(userInfo.dob.value),
					postal_code: userInfo.postalCode.value,
					mother_first_name: userInfo.motherFirstName.value,
					mother_last_name: userInfo.motherLastName.value,
					source_of_funds: userInfo.sourceOfFunds.value,
					employment_status: userInfo.employmentStatus.value,
					employer_name: userInfo.employerName.value,
					employment_industry: userInfo.employerIndustry.value,
					employer_street: userInfo.employerStreet.value,
					employer_barangay: userInfo.employerBarangay.value,
					employer_city: userInfo.employerCity.value,
					employer_province: userInfo.employerProvince.value,
					employer_postal_code: userInfo.employerPostalCode.value,
					wallet_connected: true,
					kyc: this.props.forKYC ? true : false // if forKYC is true then it is for KYC submission
				};

				for (let fileDetails of this.props.formImages) {
					const value = fileDetails.file.value;

					if (!value) continue;

					const typeObj = {
						type: 'putObject',
						fileName: value.name,
						folder: fileDetails.id
					};

					const resp = await UserService.signedUrlUploadId(this.props.currentUser.profile.id, typeObj);
					await axios.put(resp.data.signedUrl, value, {
						headers: {
							'Content-Type': ''
						}
					});
				}

				// Wallet Creation
				if (!this.props.forKYC) {
					const wallet = await this.createWallet();

					if (!wallet) {
						this.toastFail('Email already have wallet please try again with different email!');
						this.setState({ _isOptSubmitBtnLoaderOn: false });
						return;
					}

					const user = await UserService.updateUserInfo(updateUser);

					if (!user) {
						this.toastSuccess('User was not able to update!');
						this.setState({
							_isOptSubmitBtnLoaderOn: false
						});
						return;
					}
					this.toastSuccess('Wallet created successfully!');
					this.props.oncloseOtp();
					this.setState({
						_isOptSubmitBtnLoaderOn: false
					});
				} else {
					// KYC Submission
					const kyc = await this.submitKyc();

					console.log(kyc, 'kyc response upon submit');
					if (kyc.status === 'fail') {
						this.toastFail(kyc.message);
						this.setState({ _isOptSubmitBtnLoaderOn: false });
						throw new Error(kyc.message);
					}

					const user = await UserService.updateUserInfo(updateUser);

					if (!user) {
						this.toastSuccess('User was not able to update!');
						this.setState({ _isOptSubmitBtnLoaderOn: false });
						return;
					}
					this.toastSuccess(
						`You have successully submitted your Identity Verification. An email will be sent to you within 1-2 days regarding the status of your application`
					);
					this.props.oncloseOtp();
				}
			} else {
				this.setState({
					otp: '',
					_error: 'error_message.invalid_code',
					_isOptSubmitBtnLoaderOn: false
				});
			}
		} catch (err) {
			LogError(err.message);
		}
	};

	resendOtp = async () => {
		this.setState({
			_isResendingOtp: true
		});
		const message = 'signin.code_sent_successfully_email';
		try {
			this.sendOtp();
			this.showAlert(true, 'success', message);
			this.setState({
				_isResendingOtp: false
			});
		} catch (err) {
			this.showAlert(true, 'error', 'error_message.something_went_wrong');
			this.setState({
				_isResendingOtp: false
			});
		}
	};

	showAlert = async (show, severity, message) => {
		const alert = {
			_show: show,
			_message: message,
			_severity: severity
		};
		await this.setState({
			_alert: alert
		});
	};

	hideAlert = async () => {
		const alert = {
			_show: false,
			_message: '',
			_severity: ''
		};
		await this.setState({
			_alert: alert
		});
	};

	getDateFormat(dob) {
		const dobDate = getDate(dob);
		const dobMonth = getMonth(dob) + 1;
		const dobYear = getYear(dob);
		return `${dobYear}-${dobMonth}-${dobDate}`;
	}

	toastFail = msg => {
		Swal.fire({
			customClass: 'otp_message_success',

			title: 'Error',
			text: msg,
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			// icon: 'error',
			confirmButtonText: 'Try again'
		});
	};

	toastSuccess = msg => {
		Swal.fire({
			title: 'CONGRATULATIONS',
			text: msg,

			icon: { Icon },
			imageUrl: Icon,

			confirmButtonText: 'Ok',
			customClass: 'otp_message_success'
		}).then(res => {
			if (res.value) {
				window.location.reload();
			}
		});
	};

	sendOtp = async () => {
		const requestBody = {
			ValidIdNumber: this.props.dwollaSignUpForm.idNumber.value,
			ValidIdType: this.props.dwollaSignUpForm.idType.value.value,
			DateOfBirth: this.getDateFormat(this.props.dwollaSignUpForm.dob.value),
			PhysicalAddress: `${this.props.dwollaSignUpForm.address.value} ${this.props.dwollaSignUpForm.city.value}`,
			LastName: this.props.dwollaSignUpForm.lastName.value,
			FirstName: this.props.dwollaSignUpForm.firstName.value,
			EmailAddress: this.props.dwollaSignUpForm.emailId.value
		};
		try {
			const response = await BuxService.sendEmailVerification(requestBody);

			if (!response) {
				this.toastFail('Send OTP failed. Try resending OTP');
			}
		} catch (error) {
			LogError(error.message);
		}
	};

	componentDidMount() {
		this.sendOtp();
		this.allowResendOtp();
	}

	allowResendOtp = () => {
		let count = 0;
		const timer = setInterval(() => {
			++count;
			if (count == 59) {
				this.setState({
					allowResendOtp: true
				});
				clearInterval(timer);
			}
		}, 1000);
		this.setState({
			allowResendOtp: false
		});
	};

	render() {
		const { classes } = this.props;
		const { t } = this.props;

		return (
			<IIFC>
				{() => {
					const isMobile = useMediaQuery({ query: `(max-width: ${MOBILE})` });
					return (
						<>
							<Container component="main" className="kyc_otp_container">
								<PageHeaderTitle
									onClick={this.props.handleBackFromOtp}
									isMobile={isMobile}
									title="Verification Code"
									className="kyc_otp p-x-16"
								/>
								<CssBaseline />

								<Paper className={classes.paper}>
									<Grid id="full-wdith" item sm={8} xs={12} md zeroMinWidth>
										<div>
											<div className={classes.paper} id="kyc_otp">
												<Typography component="h4" gutterBottom variant="h5">
													{t('signin.text_for_otp_screen')} {t('label.email')}
												</Typography>

												<form
													noValidate
													onSubmit={this.onsubmitFormHandler}
													style={{
														width: '185px'
													}}>
													{
														<>
															<InputLabelMobile label="6-Digit Code" />
															<TextField
																autoComplete="nope"
																className="text-center kyc_otp_input_code"
																id="outlined-basic"
																label={isMobile ? null : t('label.code')}
																placeholder={isMobile ? '123456' : null}
																margin="normal"
																onChange={otp => this.otpChangeHandler(otp)}
																value={this.state.otp}
																variant="outlined"
																inputProps={{
																	style: { textAlign: 'center' }
																}}
															/>
														</>
													}
													{isMobile ? null : (
														<div
															className={classes.blockdiv}
															style={{
																display: 'flex',
																justifyContent: 'space-between'
															}}>
															<Fab
																aria-label="add"
																color="primary"
																onClick={this.props.handleBackFromOtp}
																size="medium"
																variant="extended">
																{t('buttons.back')}
															</Fab>
															<Fab
																aria-label="add"
																className={classes.submit}
																color="primary"
																size="medium"
																type="submit"
																variant="extended"
																style={{ margin: 0 }}>
																{t('buttons.submit')}
																{this.state._isOptSubmitBtnLoaderOn ? (
																	<CircularProgress
																		disableShrink
																		size={18}
																		className="ml-2"
																	/>
																) : null}
															</Fab>
														</div>
													)}
												</form>
												<Error
													text={
														this.state._errorFromEdit !== ''
															? this.state._errorFromEdit
															: t(this.state._error)
													}
												/>
												<Typography
													component="h4"
													gutterBottom
													className="receive_code"
													variant="h5">
													{t('signin.didnt_recieve_code')}
												</Typography>
												<Link
													href="#"
													className="resend_code"
													style={{
														color: isMobile
															? this.state.allowResendOtp
																? '#27B88D'
																: 'grey'
															: this.state.allowResendOtp
															? 'blue'
															: 'grey',
														pointerEvents: this.state.allowResendOtp ? '' : 'none'
													}}
													onClick={_e => {
														if (this.state.allowResendOtp) {
															this.resendOtp();
															this.allowResendOtp();
														}
													}}
													variant="body2">
													{isMobile
														? this.state._isResendingOtp
															? t('label.sending')
															: 'Send again'
														: this.state._isResendingOtp
														? t('label.sending')
														: 'Send again'}
													{/* : t('label.send_code_again')} */}
												</Link>
											</div>
										</div>
									</Grid>
								</Paper>

								<Alert
									severity={this.state._alert._severity}
									onClose={this.hideAlert}
									message={t(this.state._alert._message)}
									show={this.state._alert._show}
								/>
								<form noValidate onSubmit={this.onsubmitFormHandler} className="otp_footer">
									<Grid sm={8} xs={12} item>
										<MobileFooter
											loading={
												this.state._isOptSubmitBtnLoaderOn ? (
													<CircularProgress disableShrink size={18} className="ml-2" />
												) : null
											}
											hasNext={true}
											htmlType="Submit"
											className="kyc_otp"
											onClick={this.props.handleBackFromOtp}
											textButtonContinue={this.state._isOptSubmitBtnLoaderOn ? null : 'SUBMIT'}
										/>
									</Grid>
								</form>
							</Container>
						</>
					);
				}}
			</IIFC>
		);
	}
}

export default withStyles(commonStyle)(withTranslation()(index));
